module.exports = __webpack_public_path__ + "static/media/mte-stand.f0c9e1df.png";